export const ConvertStringToPascalCase = (str: string): string => {
   if (!str) return "";
   let removedSpecialCharacters = str.replace(/[^a-zA-Z0-9]/g, " ");
   return removedSpecialCharacters.replace(/\w\S*/g, (txt: string) => {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
   });
};
